var recaptchaForms = document.getElementsByClassName('recaptchaForm');
for (var i = 0; i < recaptchaForms.length; i++)
{
    var rForm = recaptchaForms[i];
    var rSiteKey = rForm.getElementsByClassName('recaptchaSiteKey')[0].value;
    var rActionName = rForm.getElementsByClassName('recaptchaActionName')[0].value;
    rForm.onsubmit = function (e) {
        e.preventDefault();
        executeRecaptcha(rSiteKey, rActionName, function(token) {
        	rForm.getElementsByClassName('recaptchaToken')[0].value = token;
        	rForm.submit();
    	});
    };
}

var executeRecaptcha = function (siteKey, actionName, callback) {
	grecaptcha.execute(siteKey, { action: actionName })
            .then(function (token) {
                callback(token);
            });
};

// Adds title to Google reCAPTCHA logo iframe for accessibility purposes
window.addEventListener('load', function () {
	var logo = document.getElementsByClassName('grecaptcha-logo');
	if (logo.length > 0) {
		var logoIframe = logo[0].getElementsByTagName('iframe');
		if (logoIframe.length > 0) {
			logoIframe[0].setAttribute('title', 'Google reCAPTCHA Logo');	
		}
	}
});

// Adds label to reCAPTCHA response textarea for accessibility purposes
window.addEventListener('load', function () {
	var response = document.getElementById('g-recaptcha-response-100000');
	if (response) {
		response.setAttribute('aria-label', 'reCAPTCHA response');
	}
});